import logo from "./logo.svg";
import "./App.css";
import Card from "./Component/Card.js";

function App() {
  return (
    <div className="relative min-h-screen w-full bg-gradient-to-br from-[#000000] from-60%  to-[#141414] ">
      <div className="absolute inset-0 backdrop-blur-sm bg-white/10"></div>
      <div className="relative z-10">
        <div className=" mx-4 md:mx-14 pt-10 md:flex gap-8 mb-8">
          <div className="mb-3 md:md-0">
            <img
              src="threejsIcon.png"
              className="w-24 h-24 rounded-xl transition-transform duration-300 ease-in-out transform hover:-rotate-180 cursor-pointer"
            />
          </div>
          <div>
            <p className="text-gray-300 font-bold text-2xl uppercase">
              Welcome ,{" "}
            </p>
            <p
              className="text-[#175ce6] font-bold text-2xl uppercase"
              style={{
                textShadow: "0 0 0px #175ce6, 0 0 7px #175ce6, 0 0 1px #175ce6",
              }}
            >
              to my Three js Projects!
            </p>
            <p className="mt-2 text-gray-500  ">
              Take a look around and explore the interactive experiences I’ve
              built. Click on any card to check them out!
            </p>
          </div>
        </div>
        <Card />
        <div
          className="bg-[#141414] h-20 border-y border-gray-600 pl-12 "
          style={{ boxShadow: "rgba(55, 65, 81, 0.16) 0px 5px 50px" }}
        >
          <div className="md:flex justify-between items-center h-full px-2">
            <div className="flex items-center">
              <a
                href="https://www.linkedin.com/in/riddhi-chavan-7b11b6268/"
                target="_blank"
                className="text-gray-300 hover:text-gray-200 px-2"
              >
                <img src="Linked_in.webp" className="w-10 h-10" />
              </a>
              <a
                href="https://github.com/Riddhi-chavan"
                target="_blank"
                className="text-gray-300 hover:text-gray-200 "
              >
                <img src="/github.png" className="w-20 h-20" />
              </a>
              <a
                href="https://riddhi-chavan-portfolio.vercel.app/"
                target="_blank"
                className="text-[#175ce6] font-bold  uppercase"
                style={{
                  textShadow:
                    "0 0 0px #175ce6, 0 0 4px #175ce6, 0 0 1px #175ce6",
                }}
              >
                View My Portfolio
              </a>
            </div>
            <p className="text-gray-400 text-sm flex items-center gap-5 pr-8">
              © {new Date().getFullYear()} Riddhi Chavan.{" "}
              <img
                src="myphoto.jpeg"
                className="w-10 h-10 rounded-full border border-[#175ce6]"
                style={{ boxShadow: "rgba(23, 92, 230, 0.15) 10px 10px 40px" }}
              />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
